(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bpd-home-palette-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bpd-home-palette')) {
    customElements.define(
      'bpd-home-palette',
      class BpdHomePalette extends HTMLElement {
        connectedCallback() {
          this.image = this.querySelector('[data-bpd-palette-image]');
          this.media = this.querySelector('[data-bpd-palette-media]');
          this.titleElement = this.querySelector('[data-bpd-palette-title]');
          this.copyElement = this.querySelector('[data-bpd-palette-copy]');
          this.abortController = new AbortController();
          this.addEventListener('change', this.handleChange.bind(this), {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        handleChange(event) {
          const input = event.target.closest('[data-bpd-palette-input]');
          if (!input || !this.contains(input)) return;
          this.updatePreview(input);
        }

        updatePreview(input) {
          if (!this.image || !this.media || !this.titleElement || !this.copyElement) return;

          this.media.style.setProperty('--ink-color', input.dataset.inkColor || '#245cb7');
          this.media.classList.toggle('is-original', input.value === 'Blue');
          this.image.alt = input.dataset.imageAlt || '';
          this.titleElement.textContent = input.dataset.colorName || input.value;
          this.copyElement.textContent = input.dataset.colorCopy || '';
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
